import { useState, useCallback } from "react";

export const useDragAndDrop = (onFileDrop, acceptedFileTypes = []) => {
  const [isDragOver, setIsDragOver] = useState(false);
  const [dragCounter, setDragCounter] = useState(0);

  const handleDragEnter = useCallback((e) => {
    e.preventDefault();
    e.stopPropagation();
    setDragCounter((prev) => prev + 1);
    setIsDragOver(true);
  }, []);

  const handleDragLeave = useCallback(
    (e) => {
      e.preventDefault();
      e.stopPropagation();
      setDragCounter((prev) => prev - 1);
      if (dragCounter === 0) {
        setIsDragOver(false);
      }
    },
    [dragCounter]
  );

  const handleDragOver = useCallback((e) => {
    e.preventDefault();
    e.stopPropagation();
  }, []);

  const handleDrop = useCallback(
    (e) => {
      e.preventDefault();
      e.stopPropagation();
      setIsDragOver(false);
      setDragCounter(0);

      const files = Array.from(e.dataTransfer.files);

      if (files.length > 0) {
        const file = files[0];

        if (acceptedFileTypes.length > 0) {
          const fileExtension = file.name.split(".").pop().toLowerCase();
          if (!acceptedFileTypes.includes(fileExtension)) {
            alert(`Invalid file type! Please choose a ${acceptedFileTypes.join(", ")} file.`);
            return;
          }
        }

        onFileDrop(file);
      }
    },
    [onFileDrop, acceptedFileTypes]
  );

  return {
    isDragOver,
    dragHandlers: {
      onDragEnter: handleDragEnter,
      onDragLeave: handleDragLeave,
      onDragOver: handleDragOver,
      onDrop: handleDrop,
    },
  };
};
